import type { AddToCommunityFormState } from '../add-user-to-community';

export const validateAddUserToCommunity = (values: AddToCommunityFormState) => ({
  network: !values.network,
});
